import { getDateFormat } from 'helpers/dates'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import moment from 'moment'
import ListFromTable from 'components/common/ListFromTable'
import {
  locusFetchTableData,
  locusClearStateList,
  locusDelete,
} from 'reducers/locus/reducer'
import { fetchLocusGroupList } from 'reducers/locusGroup/reducer'
import * as ROUTE from 'constants/appRouting'
import ColumnCollection from 'types/table/ColumnCollection'
import Column from 'types/table/Column'
import ActiveColumn from 'types/table/ActiveColumn'
import Sort from 'lib/psfs/Sort'
import ActionCollection from 'types/table/ActionCollection'
import Action from 'types/table/Action'
import UrlHelper from 'helpers/url'
import RoleHelper from 'helpers/role'
import messages from './translate'

class LocusList extends ListFromTable {
  constructor(props) {
    super(props)
    this.getTableData = props.locusFetchTableData
    this.deleteEntity = props.locusDelete
    this.clearReducerState = props.locusClearStateList
    this.asyncData = true
    this.loadingData = true
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { licenseeId, tableData } = this.props

    if (nextProps.licenseeId !== licenseeId) {
      this.reloadTableData(ROUTE.LOCUS_LIST)

      return false
    }

    if (tableData !== nextProps.tableData) {
      this.loadingData = false
    }

    return super.shouldComponentUpdate(nextProps, nextState, nextContext)
  }

  getTableProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.locus_list),
      showFilterBar: true,
      sorting: true,
      paging: true,
      searching: true,
      creating: true,
    }
  }

  getCreateButton() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.create_locus),
      link: ROUTE.LOCUS_CREATE,
    }
  }

  getConfirmDialogProps() {
    const {
      intl: { formatMessage },
    } = this.props

    return {
      title: formatMessage(messages.delete_locus),
      message: formatMessage(messages.delete_locus_message),
    }
  }

  getColumns() {
    const {
      intl: { formatMessage },
      roleLevel,
      licensee: { usaDateFormat },
    } = this.props
    const columns = new ColumnCollection()
    const dateDisplay = getDateFormat(usaDateFormat)

    columns.add(new Column('id', 'ID', { sorting: true }))
    columns.add(
      new Column('containerName', formatMessage(messages.name), {
        sorting: true,
        defaultSort: true,
        defaultSortOrder: Sort.ASC,
      }),
    )
    columns.add(
      new Column('site', formatMessage(messages.site), {
        sorting: true,
        render: rowData => rowData.site.name,
      }),
    )
    columns.add(
      new Column('locusGroups', formatMessage(messages.locusGroup), {
        render: rowData =>
          rowData.locusGroups.map(group => group.name).join(', '),
      }),
    )
    if (roleLevel >= RoleHelper.ROLE_ADMIN_LEVEL) {
      columns.add(
        new ActiveColumn('active', formatMessage(messages.active), {
          sorting: true,
        }),
      )
      columns.add(
        new ActiveColumn('visibleInUi', formatMessage(messages.visibleInUi), {
          sorting: true,
        }),
      )
    }
    columns.add(
      new Column('dateUpdated', formatMessage(messages.date_updated), {
        sorting: true,
        render: row => moment(row.dateUpdated).format(dateDisplay),
      }),
    )

    return columns
  }

  getActions() {
    const {
      history,
      roleLevel,
      intl: { formatMessage },
    } = this.props
    const actions = new ActionCollection()

    if (roleLevel >= RoleHelper.ROLE_ADMIN_LEVEL) {
      actions.add(
        new Action('edit', formatMessage(messages.editUnitData), row => {
          history.push(UrlHelper.create(ROUTE.LOCUS_EDIT, { id: row.id }))
        }),
      )
      actions.add(
        new Action('delete', formatMessage(messages.removeUnit), row => {
          this.onOpenConfirmDialog({
            entityId: row.id,
            psfs: this.psfs,
          })
        }),
      )
    }

    return actions
  }
}

export default connect(
  state => ({
    tableData: state.getIn(['locus', 'tableData']),
    locusGroupList: state.getIn(['locusGroup', 'locusGroupList']),
    licenseeId: state.getIn(['profile', 'licenseeId']),
    roleLevel: state.getIn(['profile', 'roleLevel']),
    licensee: state.getIn(['profile', 'profile', 'licensee']),
  }),
  {
    locusFetchTableData,
    fetchLocusGroupList,
    locusDelete,
    locusClearStateList,
  },
)(injectIntl(LocusList))
